import { parse } from 'date-fns';
import { format } from 'date-fns';


export const parseFormattedDate = (dateStr) => {
    return parse(dateStr, 'dd.MM.y', new Date());
};

export const formatDate = (date) => {
    return format(date, 'dd.MM.yyyy');
}

export const dateToIso = (date) => {
    return format(date, 'yyyy-MM-dd');
}

export const formatDatetime = (datetime) => {
    return format(datetime, 'dd.MM.yyyy HH:mm:ss')
}
